export function formatPercent(value, showSymbol = true) {
    const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(value / 100);
    return showSymbol ? formatted : formatted.replace('%', '');
}
